<!-- page title play and earn -->
<ng-container *ngIf="isTokenValid && templateLoaded && gameGrid">
    <div role="heading" aria-level="1"  class="title-md-bold mt-3 mb-1">{{PlayEarn}}</div>
    <div class="pb-1 title-sm color-neutral-700">{{PlayEarnSub}}</div>
</ng-container>
<!-- page title play and earn end -->

<!-- game center page start here -->
<ng-container *ngIf="isTokenValid && templateLoaded && gameGrid && gamesExist">
    <games-grid [userInfo]="userInfo"></games-grid>
</ng-container>
<ng-container *ngIf="isTokenValid && templateLoaded && gameGrid && bonusPathExist">
    <app-bonus-path></app-bonus-path>
</ng-container>
<!-- game center page end here -->

<!-- gameDetails  page start here -->
<div *ngIf="isTokenValid && templateLoaded && gameDetails">
    <games-grid [userInfo]="userInfo" [singleCard]="singleCard" [selectedGame]="selectedGame"></games-grid>
    <app-opt-in [userInfo]="userInfo" [singleCard]="singleCard" [programId]="selectedGame"></app-opt-in>
    <app-jump-list  [selectedGame]="selectedGame" [prizeGrid]="prizeGrid" [myPrizeList]="myPrizeList" [activity]="activity"></app-jump-list>
    <div class="section" #prizeGrid>
        <app-prize-grid [userInfo]="userInfo" [gameId]="selectedGame">
        </app-prize-grid>
    </div>
    <div class="section" #myPrizeList>
        <app-my-prize-list [userInfo]="userInfo" [gameId]="selectedGame">
        </app-my-prize-list>
    </div>
    <div class="section" #activity>
        <app-token-activity [userInfo]="userInfo" [gameId]="selectedGame"></app-token-activity>
    </div>
    <div class="section" #gameDisclaimer>
        <app-game-disclaimer></app-game-disclaimer>
    </div>
</div>
<!-- gameDetails page end here -->

<!-- gamePrizeDetails page start here -->
<ng-container *ngIf="isTokenValid && templateLoaded && gamePrizeDetails">
    <prize-details [userInfo]="userInfo"></prize-details>
</ng-container>
<!-- gamePrizeDetails page end here -->

<!-- gameOverPage page start here -->
<ng-container *ngIf="isTokenValid && templateLoaded && gameOverPage">
    <app-game-summary [userInfo]="userInfo" [programId]="selectedGame"></app-game-summary>
</ng-container>
<!-- gameOverPage page end here -->

<!-- noGames and noBonus path scenario template -->
<ng-container *ngIf="!gamesExist && !bonusPathExist">
    <div class="game-grid mt-10 mb-10">
        <div tabindex="0" class="message noGameContainer">
            <div class="noGameImg text-center mt-10 mb-3"><img src="/ocgp-games-ui/dist/assets/images/challenges.svg"></div>
            <div class="text-center title center color-neutral-700">{{noGamesBonus}}</div>
            <div class="text-center title center color-neutral-700">{{continueExploring}}<a href="/foru/coupons-deals.html" class="links__action__inline underline">save.</a></div>    
        </div>
    </div>
</ng-container>
<!-- noGames and noBonus path scenario template end-->
